<template>
	<div>
		<ul class="small-block-grid-2 medium-block-grid-2">
			<li v-for="eachSetting in settingsJson" v-if="paymentSettings[eachSetting.title_setting]=='true' && validLabel(eachSetting.inputs)">
				<AlternativePayment :setting="eachSetting"></AlternativePayment>
			</li>
		</ul>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import AlternativePayment from './AlternativePayment';

export default {
	name: 'Public',
	data () {
		return  {

		}
	},
	computed: {
		...mapGetters([
			'paymentSettings',
			'settingsJson'
		]),
	},
	methods: {
		validLabel: function(inputs){



			if(!(inputs.length > 0)) {
				return true
			}


			for (var i = 0; i < inputs.length; i++) {
				if (this.paymentSettings[inputs[i].setting]!=''){
					return true;
				}
			}
			return false;
		}
	},
	components: {
		AlternativePayment
	},
	created () {
		this.$store.dispatch('GET_PAYMENT_SETTINGS')
			.then( response => this.$store.dispatch('GET_JSON'));
	}

}

</script>



<style scoped>

</style>
